import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import ViewUser from "./ViewUser";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { adminApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function ResetUserPassword(props) {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const { id } = useParams();
  const [user, setUser] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  useEffect(() => {
    adminApi
      .get("/Users/" + id, {
        signal: source.current.signal
      })
      .then(data => setUser(data))
      .catch(error => console.log(error));
  }, [id]);

  const [newPassword, setNewPassword] = React.useState(null);
  const handleNewPasswordChanged = e =>
    setNewPassword(e.target.value === "" ? null : e.target.value);
  const handleSubmit = e => {
    e.preventDefault();
    adminApi
      .post(
        "/Users/ResetPassword",
        {
          id: id,
          newPassword: newPassword
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => console.log(error));
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to="/admin/UserList" />
  ) : (
    user !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>RESET USER PASSWORD</h4>
            </CardHeader>
            <CardBody>
              <p>
                <i>
                  *Please ask the user to Change the password immediately after
                  reset.
                </i>
              </p>
              <form onSubmit={handleSubmit}>
                <CustomInput
                  labelText="New Password"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleNewPasswordChanged,
                    value: newPassword === null ? "" : newPassword
                  }}
                />
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  Cancel
                </Button>
                <Button color="rose" type="submit" value="Submit">
                  RESET PASSWORD
                </Button>
              </form>
              <ViewUser user={user} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

ResetUserPassword.propTypes = {
  history: PropTypes.object
};
